var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { useContext, useEffect } from "react";
import { defaultDialogOptions, DialogStateContext } from "../context/dialog-state-context";
import { propMerge } from "@shapeable/utils";
export var useDialogs = function (options) {
  var useOpts = propMerge(defaultDialogOptions, options || {});
  var _a = __read(useContext(DialogStateContext), 2),
    state = _a[0],
    setState = _a[1];
  var _b = state.items,
    items = _b === void 0 ? [] : _b;
  useEffect(function () {
    if (useOpts.preventScroll) {
      if (document !== undefined && document.body !== undefined) {
        if (items.length > 0) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = 'auto';
        }
      }
    }
  }, [items === null || items === void 0 ? void 0 : items.length]);
  return {
    show: function (component, options) {
      var opts = propMerge(useOpts, options || {});
      var dialogState = {
        component: component,
        options: opts
      };
      var newState = __assign(__assign(__assign({}, state), {
        items: [dialogState]
      }), options || {});
      setState(newState);
    },
    push: function (component, options) {
      var opts = propMerge(useOpts, options || {});
      var dialogState = {
        component: component,
        options: opts
      };
      var newState = __assign(__assign(__assign({}, state), {
        items: __spreadArray(__spreadArray([], __read(items), false), [dialogState], false)
      }), options || {});
      setState(newState);
    },
    pop: function () {
      var newState = __assign(__assign({}, state), {
        items: items.slice(0, items.length - 1)
      });
      setState(newState);
    },
    hide: function () {
      setState(__assign(__assign({}, state), {
        items: []
      }));
    },
    items: items,
    isVisible: items.length > 0
  };
};